import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import { SelectStore } from "./pages/select";
import Shop from "./pages/shop";
import { LastStep } from "./pages/confirmation";
import { PayPalReturn } from "./pages/paypal-return";
import { XsollaReturn } from "./pages/xsolla-return";
import { UTMProvider } from "./contexts/UTMContext";
import { UserProvider } from "./UserProvider";
import Error from "./pages/error";

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route path="/404" children={<Error />} />
      <Route exact path="/paypal/return" children={<PayPalReturn />} />
      <Route exact path="/xsolla/return" children={<XsollaReturn />} />
      <UserProvider>
        <UTMProvider>
          <Switch>
            <Route exact path="/" children={<SelectStore />} />
            <Route exact path="/:server/checkout/:gateway" children={<LastStep />} />
            <Route exact path="/:server" children={<Shop />} />
          </Switch>
        </UTMProvider>
      </UserProvider>
    </Switch>
  </BrowserRouter>
);

export default Routes;
